import { FC, useEffect, useMemo, useState } from 'react';
import FeaturesItems from '../FeaturesItems/FeaturesItems';
import { StyledContainer, StyledDescription, StyledTitle } from './styles';
import Typography from '@mui/material/Typography';
import { useAppSelector } from '../../../hooks/reduxHooks';
import { IProduct } from '../../../interfaces/product';

interface FeaturesProps {
  ssrProduct?: IProduct;
  onlyKeys?: boolean;
  onlyValues?: boolean;
}

const Features: FC<FeaturesProps> = ({ ssrProduct, onlyKeys, onlyValues }) => {
  const stateProduct = useAppSelector((st) => st.products.product);
  const [product, setProduct] = useState<IProduct | undefined>(ssrProduct);
  const locale = useAppSelector((st) => st.locale);

  useEffect(() => {
    if (stateProduct) setProduct(stateProduct);
  }, [stateProduct]);
  const data = useMemo(
    () => [
      {
        title: locale.product_features_title_watch_details,
        description: [
          {
            key: locale.product_features_watch_details_description_key_0,
            value: product?.model?.brand?.name,
            urlSlug: product?.model?.brand?.urlSlug,
          },
          {
            key: locale.product_features_watch_details_description_key_1,
            value: product?.refNumber,
          },
          {
            key: locale.product_features_watch_details_description_key_2,
            value: product?.model?.name,
            urlSlug: product?.model?.urlSlug,
          },
          {
            key: locale.product_features_watch_details_description_key_3,
            value: product?.scopeDelivery,
          },
          {
            key: locale.product_features_watch_details_description_key_4,
            value: product?.dealerProductCode,
          },
          {
            key: locale.product_features_watch_details_description_key_5,
            value: product?.availability,
          },
          {
            key: locale.product_features_watch_details_description_key_6,
            value: product?.condition,
          },
          {
            key: locale.product_features_watch_details_description_key_7,
            value: product?.yearProduction,
          },
        ],
      },
      {
        title: locale.product_features_title_case_dial,
        description: [
          {
            key: locale.product_features_case_dial_description_key_0,
            value: product?.caseMaterial,
          },
          {
            key: locale.product_features_case_dial_description_key_1,
            value: product?.movement,
          },
          {
            key: locale.product_features_case_dial_description_key_2,
            value: product?.caseDiameter,
          },
          {
            key: locale.product_features_case_dial_description_key_3,
            value: product?.dial,
          },
          {
            key: locale.product_features_case_dial_description_key_4,
            value: product?.crystal,
          },
          {
            key: locale.product_features_case_dial_description_key_5,
            value: product?.bezelMaterial,
          },
          {
            key: locale.product_features_case_dial_description_key_6,
            value: product?.dialNumerals,
          },
        ],
      },
      {
        title: locale.product_features_title_strap_bracelet,
        description: [
          {
            key: locale.product_features_strap_bracelet_description_key_0,
            value: product?.braceletColor,
          },
          {
            key: locale.product_features_strap_bracelet_description_key_1,
            value: product?.braceletMaterial,
          },
          {
            key: locale.product_features_strap_bracelet_description_key_2,
            value: product?.clasp,
          },
          {
            key: locale.product_features_strap_bracelet_description_key_3,
            value: product?.claspMaterial,
          },
        ],
      },
    ],
    [product, locale]
  );
  return (
    <div style={{ marginTop: '6px' }}>
      {data
        ?.filter((item) => item.description.some((des) => des.value))
        ?.map((item, index) => (
          <StyledContainer key={index}>
            <StyledTitle>
              <Typography variant={'h3'} sx={{ fontSize: '32px', lineHeight: '44px' }}>
                {item.title}
              </Typography>
            </StyledTitle>

            <StyledDescription>
              <FeaturesItems
                data={item.description}
                activeCols={['BrandName', 'ModelName']}
                onlyKeys={onlyKeys}
                onlyValues={onlyValues}
              />
            </StyledDescription>
          </StyledContainer>
        ))}
    </div>
  );
};

export default Features;
